import { Link } from "react-router-dom";

import styles from "./HighlightButton.module.css";

export function HighlightButton({ onClick, children, disabled = false }) {
  return (
    <button type="button" className={[styles.highlightButton, disabled ? styles.disabled : ''].join(' ')} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export function SecondaryButton({ onClick, children, disabled = false }) {
  return (
    <button type="button" className={[styles.secondaryButton, disabled ? styles.disabled : ''].join(' ')} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}


// Not an actual button, but a Link styled as one
export function LinkHighlightButton({ to = "/", children }) {
  return (
    <Link to={to} className={styles.linkHighlightButton}>
      {children}
    </Link>
  )
}